module.exports = __webpack_public_path__ + "static/media/potraitAnalytics.4ae73ac0.png";